import styled from 'styled-components';

export const StyledPeselField = styled.div`
   width: 278px;
`;
StyledPeselField.displayName = 'StyledPeselField';
